import YellowStar from 'shared/components/icon-pack/icons/YellowStar'

const VipBadge = () => {
  return (
    <div
      style={{
        background:
          'linear-gradient(90deg, rgba(249, 224, 135, 0.15) 0%, rgba(240, 204, 110, 0.15) 100%)',
      }}
      className="flex items-center justify-center px-3 ml-4"
    >
      <YellowStar />
      <p className="leading-8 text-xs font-medium text-[#FFA800] mr-2 mt-1">
        VIP
      </p>
    </div>
  )
}

export default VipBadge
